import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const USER_BASE_URL =
  `${API_BASE_URL}/user`;

// ==========================
// UPDATE USER PROFILE DETAILS
// ==========================
export const updateUserProfileDetailsApi =
  async (
    formData: FormData
  ) => {
    try {
      const res =
        await axios.put(
          `${USER_BASE_URL}/profile/details`,
          formData
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,
        data: null,
        message:
          error?.response?.data
            ?.message ||
          "Failed to update profile",
      };
    }
  };